import { ManagedCategory } from '../interfaces/managed-category-interfaces/managed-category.interface';

export const CATEGORY = 'Category';

export const CATEGORY_NONE = { name: 'None', value: 'None' };

export const CATEGORY_NONE_BACKUP: ManagedCategory =  {
  id: CATEGORY_NONE.value,
  name: CATEGORY_NONE.name,
  permission: "",
  approvalInfoUrl: "",
  approvalRequired: false
}
